<template>
  <div id="add_form" class="modal custom-modal fade qr-editor-modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content qr-editor-modal-content">
        <div class="modal-header qr-editor-header">
          <div>
            <h5 class="modal-title" v-if="formParam.header.id != '' && formParam.header.id != null">
              Edit Quick Reply
            </h5>
            <h5 class="modal-title" v-else>Tambah Quick Reply</h5>
            <p class="qr-editor-subtitle">
              Buat balasan siap pakai untuk chat WhatsApp.
            </p>
          </div>
          <button
            ref="dismisModal"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body qr-editor-body">
          <div v-if="errors.form" class="qr-alert is-error">
            <i class="fa fa-exclamation-circle"></i>
            <span>{{ errors.form }}</span>
          </div>

          <div class="row qr-editor-grid">
            <div class="col-lg-7 qr-editor-left">
              <div class="qr-form-section">
                <label class="qr-field-label" for="qr-title">
                  Judul Quick Reply
                  <span class="text-danger">*</span>
                </label>
                <div class="qr-title-input-wrap" :class="{ 'is-invalid': errors.title }">
                  <input
                    id="qr-title"
                    v-model="formParam.header.title"
                    type="text"
                    class="form-control qr-title-input"
                    maxlength="50"
                    placeholder="Contoh: Sambutan pelanggan baru"
                    :disabled="isSending"
                    @input="errors.title = ''"
                  />
                  <span class="qr-char-count">{{ titleLength }}/50</span>
                </div>
                <p v-if="errors.title" class="qr-field-error">{{ errors.title }}</p>
                <p v-else class="qr-field-help">Maksimal 50 karakter.</p>
              </div>

              <div class="qr-form-section">
                <label class="qr-field-label">
                  Pesan WhatsApp
                  <span class="text-danger">*</span>
                </label>
                <variable-chat-editor
                  v-model="formParam.header.message"
                  dynamic-group-label="Variabel Dinamis"
                  @input="errors.message = ''"
                />
                <p v-if="errors.message" class="qr-field-error">{{ errors.message }}</p>
                <p v-else class="qr-field-help">
                  Gunakan toolbar untuk emoji, format teks, dan menyisipkan variabel.
                </p>
              </div>

              <div class="qr-form-section qr-advanced-section">
                <button
                  type="button"
                  class="qr-section-toggle"
                  @click="showAdvanced = !showAdvanced"
                >
                  <span>
                    <i class="fa" :class="showAdvanced ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                    Pengaturan tambahan
                  </span>
                  <small>Lampiran &amp; quick reply terkait</small>
                </button>

                <div v-show="showAdvanced" class="qr-advanced-body">
                  <div class="qr-subsection">
                    <div class="qr-subsection-head">
                      <div>
                        <strong>Lampiran</strong>
                        <small>Kirim gambar atau dokumen bersama pesan.</small>
                      </div>
                      <label class="qr-switch">
                        <input
                          v-model="formParam.header.is_enable_attach_file"
                          type="checkbox"
                          :disabled="isSending"
                          @click="updateMessageTypeCurrent('')"
                        />
                        <span class="qr-switch-slider"></span>
                      </label>
                    </div>

                    <div v-if="formParam.header.is_enable_attach_file" class="qr-attachment-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <label class="qr-field-label">Tipe lampiran</label>
                          <select
                            v-model="uploadMessageType"
                            class="form-control qr-select"
                            :disabled="isSending"
                            @change="updateMessageTypeCurrent(uploadMessageType)"
                          >
                            <option
                              v-for="(opt, index) in messageTypeOptionsUpload"
                              :key="index"
                              :value="opt"
                            >
                              {{ opt }}
                            </option>
                          </select>
                        </div>
                        <div class="col-sm-6">
                          <label class="qr-field-label">Sumber file</label>
                          <label class="qr-check-inline">
                            <input
                              v-model="formParam.header.is_custom_url"
                              type="checkbox"
                              :disabled="isSending"
                            />
                            Gunakan URL file
                          </label>
                        </div>
                      </div>

                      <div v-if="formParam.header.is_custom_url" class="form-group qr-custom-url">
                        <label class="qr-field-label">Image / File URL</label>
                        <input
                          v-model="formParam.header.image_url"
                          type="text"
                          class="form-control qr-input"
                          placeholder="https://..."
                          :disabled="isSending"
                          @input="errors.attachment = ''"
                        />
                      </div>

                      <div v-else class="qr-upload-area">
                        <div
                          v-show="files.length == 0"
                          class="upload-drop-zone qr-drop-zone"
                          id="drop-zone"
                        >
                          <center>
                            <i class="fa fa-cloud-upload fa-2x"></i>
                            <span class="upload-text">
                              <label :for="name">
                                Tarik dan lepas file di sini, atau klik untuk memilih file
                              </label>
                            </span>
                          </center>
                        </div>

                        <ul class="upload-list" v-if="files.length">
                          <li v-for="file in files" :key="file.id" class="file-list">
                            <div class="upload-wrap">
                              <div class="file-name">
                                <img style="width:30px;" v-if="file.thumb" :src="file.thumb" />
                                {{ file.name }}
                              </div>
                              <div class="file-size">{{ formatSizes(file.size) }}</div>
                              <div class="file-close">
                                <span class="text-danger" v-if="file.error">{{ file.error }}</span>
                                <span v-else-if="file.success">
                                  <i class="text-success fa fa-check-circle"></i>
                                </span>
                                <span v-else-if="file.active">active</span>
                                <span v-else></span>

                                <a
                                  href="#"
                                  @click.prevent="$refs.uploadbc.remove(file)"
                                  class="text-warning"
                                >
                                  <i class="fa fa-trash-o"></i>
                                </a>
                              </div>
                            </div>

                            <div
                              class="progress progress-xs progress-striped"
                              v-if="file.active || file.progress !== '0.00'"
                            >
                              <div
                                class="progress-bar bg-success"
                                role="progressbar"
                                :style="{ width: file.progress + '%' }"
                              ></div>
                            </div>
                            <div
                              class="upload-process"
                              v-if="file.active || file.progress !== '0.00'"
                            >
                              {{ file.progress }}% done
                            </div>
                          </li>
                        </ul>

                        <div class="qr-hidden-upload">
                          <file-upload-bc
                            :add-index="true"
                            :data="objFilesMessageHandler"
                            :post-action="uploadUrl"
                            :multiple="false"
                            :headers="headers"
                            :drop="true"
                            :drop-directory="true"
                            v-model="files"
                            @input-filter="inputFilter"
                            @input-file="inputFile"
                            ref="uploadbc"
                            :maximum="maximumUpload"
                            :extensions="extensions"
                          >
                            <img src="@/assets/attachment.png" alt />
                          </file-upload-bc>
                        </div>
                      </div>

                      <div v-if="formParam.header.image_url" class="qr-file-preview">
                        <a
                          v-if="formParam.header.message_type == 'document'"
                          target="_blank"
                          :href="formParam.header.image_url"
                        >
                          <i class="fa fa-file"></i> Lihat file
                        </a>
                        <a
                          v-else
                          target="_blank"
                          :href="formParam.header.image_url"
                        >
                          <img :src="formParam.header.image_url" alt="Lampiran" />
                        </a>
                      </div>

                      <p class="qr-field-help">
                        Support: {{ extensions }}. Maksimal 10 MB.
                      </p>
                      <p v-if="errors.attachment" class="qr-field-error">{{ errors.attachment }}</p>
                    </div>
                  </div>

                  <div class="qr-subsection">
                    <div class="qr-subsection-head">
                      <div>
                        <strong>Quick Reply terkait</strong>
                        <small>Pilih balasan yang tampil bersama pesan ini.</small>
                      </div>
                    </div>
                    <text-reply v-model="formParam" :isShowForm="isShowForm" />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-5 qr-editor-right">
              <div class="qr-preview-panel">
                <div class="qr-preview-header">
                  <div>
                    <h6>Preview WhatsApp</h6>
                    <p>Ini adalah contoh tampilan pesan di WhatsApp.</p>
                  </div>
                  <span class="qr-preview-badge">Contoh</span>
                </div>

                <div class="qr-preview-canvas">
                  <preview-message
                    :preview-data="formParam"
                    :textReplyRows="textReplyRows"
                    :buttonsRows="buttonsRows"
                    :linkRows="linkRows"
                  />
                </div>

                <div class="qr-preview-note">
                  <i class="fa fa-info-circle"></i>
                  <div>
                    <strong>Preview menggunakan contoh data.</strong>
                    <span>Nama: Jojo · Nomor: 6281234567890</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer qr-editor-footer">
          <button
            type="button"
            class="btn qr-btn-secondary"
            data-dismiss="modal"
            :disabled="isSending"
          >
            Batal
          </button>
          <div class="qr-footer-actions">
            <button
              type="button"
              class="btn qr-btn-link"
              :disabled="isSending"
              @click="saveForm(1, 0)"
            >
              <i class="fa fa-check"></i> Publish &amp; Keluar
            </button>
            <button
              type="button"
              class="btn qr-btn-secondary"
              :disabled="isSending"
              @click="saveForm(0, 1)"
            >
              <i class="fa fa-save"></i> Simpan Draft
            </button>
            <button
              type="button"
              class="btn btn-primary qr-btn-primary"
              :disabled="isSending"
              @click="saveForm(0, 0)"
            >
              <i v-if="isSending" class="fa fa-spinner fa-spin"></i>
              <i v-else class="fa fa-paper-plane"></i>
              {{ isSending ? "Menyimpan..." : "Publish" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { APICore, APICoreV2 } from "@/utils/servicesApi";
import { getXAuthAgent, getXAuthToken, getAgentSession } from "@/utils/auth";

import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";
import FileUpload from "vue-upload-component";
import Cropper from "cropperjs";
import ImageCompressor from "@xkeshi/image-compressor";
import { VueChatEmoji, emojis } from "vue-chat-emoji";
require("vue-chat-emoji/dist/vue-chat-emoji.min.css");
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css"); 
import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";

import PreviewMessage from "./preview";
import VariableChatEditor from "@/views/broadcast/componentsV2/Forms/chatComponent.vue";
import {
  formatDate,
  formatDateForMessage,
  getWhatsappNumberFromJid,
  formatSizes,
  currentDateTimeUTC
} from "@/utils/helper";
import TextReply from '@/components/TextReply/index.vue';
export default {
  components: {
    Skeleton,
    FileUploadBc: FileUpload,
    Emoji: VueChatEmoji,
    Multiselect,
    Datetime,
    PreviewMessage,
    TextReply,
    VariableChatEditor
  },
  props: {
    searchData: {
      type: Function
    }
  },
  data() {
    return {
      textReplyRows: [],
      textReplyParams: {
        columnFilters: {
          id: "",
          title: "",
          is_publish: "publish",
        },
        page: 1,
        perPage: 500 // perPage
      },
      interactiveMessageType: [
        // { id: "button", label: "Button" },
        // { id: "link", label: "Link/Call" },
        { id: "text_reply", label: "Text Reply" },
        // { id: "list_text", label: "List" }
      ],
      defaultDetailTextReply: 10,
      tabMessage: "setup", //setup or preview
      whatsappBackground: process.env.VUE_APP_WHATSAPP_BACKGROUND,
      objFilesMessageHandler: {
        file: null,
        // message_media: messaegMedia,
        message_type: ""
      },
      messageTypeOptionsSupport: ["text only", "media"],
      uploadMessageSupportSelected: "text only",
      messageTypeOptionsUpload: ["image", "document"],
      uploadMessageType: "image",
      caption: "",
      name: "file",
      thumbUpload: [],
      uploadAuto: true,
      uploadUrl:
        // process.env.VUE_APP_BASE_API + this.APICore() + "/omni/room/send-file",
        process.env.VUE_APP_BASE_API +
        this.APICore() +
        "/omni/only-upload-filev2",
      maximumUpload: 1,
      accept: "image/jfif,image/png,image/gif,image/jpeg,image/webp",
      extensions: "jfif, gif,jpg,jpeg,png,webp,zip,pdf,xls,xlsx, doc, docx",
      minSize: 1024,
      size: 1024 * 1024 * 10,
      files: [],
      buttonsLoading: false,
      linkParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: ""
        },
        page: 1,
        perPage: 500 // perPage
      },
      buttonsParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: ""
        },
        page: 1,
        perPage: 500 // perPage
      },
      buttonsRows: [],
      linkRows: [],
      selectedLicense: [],
      licenseOptions: [],
      licenseListParam: {
        id: "",
        license_name: "",
        license_phone_number: "",
        license_status: "",
        page: 0,
        perPage: 20
      },
      isLoadingLicense: false,
      emojiAttr2: {
        open: false,
        width: "0%",
        height: "0px"
      },
      emojiAttr: {
        open: false,
        width: "0%",
        height: "0px"
      },
      templateMessage: [
        "${first_name}",
        "${last_name}",
        "${phone_number}",
        "${email}",
        "${month_current}",
        "${month_current_name}",
        "${year_current}",
        "${today}",
        "${yesterday}",
        "${month_ago}",
        "${month_ago_name}",
        "${year_ago}"
      ],
      isSending: false,
      defaultDetailButton: 10,
      defaultDetailListText: 10, //max 10
      formParam: {
        header: {
          id: "",
          title: "",
          message: "",
          is_enable_attach_file: false,
          footer_message: "",
          footer_message_status: false,
          is_custom_url: false,
          image_url: "",
          message_type: "text",
          button_type: "text_reply",
          button_type_away_message: "text_reply"
        },
        detail_button: [
          {
            auto_reply_button_id: ""
          },
          {
            auto_reply_button_id: ""
          },
          {
            auto_reply_button_id: ""
          },
          {
            auto_reply_button_id: ""
          },
          {
            auto_reply_button_id: ""
          },
          {
            auto_reply_button_id: ""
          },
          {
            auto_reply_button_id: ""
          },
          {
            auto_reply_button_id: ""
          },
          {
            auto_reply_button_id: ""
          },
          {
            auto_reply_button_id: ""
          }
        ]
      },
      isLoading: false,
      showAdvanced: false,
      titleMaxLength: 50,
      errors: {
        title: "",
        message: "",
        attachment: "",
        form: ""
      }
    };
  },
  watch: {
    selectedLicense: {
      handler: function(val, oldVal) {
        // console.log("selectedLicense", val, oldVal);
        if (val.length > 1 && val != oldVal) {
          var that = this;
          setTimeout(function() {
            // if (
            //   that.broadcastParam.broadcast_id != "" &&
            //   that.broadcastParam.broadcast_id != null
            // ) {
            let lengthOld = oldVal.length;
            val.splice(0, 1);
            that.selectedLicense = val;
            that.formParam.header.license_id = val[0].id;
            return;
            // }
          }, 300);
        }

        // if (val != oldVal) {
        if (val.length == 1) {
          this.selectedLicense = val;
          this.formParam.header.license_id = val[0].id;
          return;
        }
        if (val != oldVal && oldVal.length == 1 && val.length < 1) {
          this.selectedLicense = [];
          this.formParam.header.license_id = "";
          return;
        }
      },
      deep: true
    },
    isShowForm: {
      handler: function(val, oldVal) {
        // console.log("val", val, "oldVal", oldVal);
        if (val == true) {
          this.settabMessage("setup");
          this.resetValidation();
          this.showAdvanced = false;
          this.files = [];
          this.uploadMessageType = "image";
          this.selectedLicense = [];
          this.buttonsRows = [];
          this.linkRows = [];
          var that = this;
          setTimeout(function() {
            // console.log("that.broadcastParamSt", that.broadcastParamSt);
            if (
              that.formParamQRSt.header.id != "" &&
              that.formParamQRSt.header.id != null
            ) {
              if (
                typeof that.formParamQRSt.header.copy != "undefined" &&
                that.formParamQRSt.header.copy == true
              ) {
                that.formParamQRSt.header.id = "";
              }

              that.formParam = that.formParamQRSt;
              that.formParam.header.title = that.formParamQRSt.header.title || "";
              that.showAdvanced =
                that.formParam.header.is_enable_attach_file == true ||
                (that.formParam.detail_button || []).some(function(row) {
                  return row.auto_reply_button_id != "";
                });

              if (that.formParam.header.image_url != "") {
                that.formParam.header.is_enable_attach_file = true;
                that.uploadMessageType = that.formParam.header.message_type;
              } else {
                that.uploadMessageType = "image";
              }

              if (
                that.formParam.header.button_type == "button" ||
                that.formParam.header.button_type == "link"
              ) {
                if (
                  that.formParam.detail_button.length < that.defaultDetailButton
                ) {
                  let kekuranganBtn =
                    that.defaultDetailButton -
                    that.formParam.detail_button.length;
                  if (that.formParam.header.button_type == "list_text") {
                    kekuranganBtn =
                      that.defaultDetailListText -
                      that.formParam.detail_button.length;
                  }
                  for (var i = 0; i < kekuranganBtn; i++) {
                    that.formParam.detail_button.push({
                      auto_reply_button_id: ""
                    });
                  }
                }
              } else {
                if (
                  that.formParam.detail_button.length <
                  that.defaultDetailListText
                ) {
                  let kekuranganBtn =
                    that.defaultDetailButton -
                    that.formParam.detail_button.length;
                  if (that.formParam.header.button_type == "list_text") {
                    kekuranganBtn =
                      that.defaultDetailListText -
                      that.formParam.detail_button.length;
                  }
                  for (var i = 0; i < kekuranganBtn; i++) {
                    that.formParam.detail_button.push({
                      auto_reply_button_id: ""
                    });
                  }
                }
              }

              that.loadTextReply();
              // that.loadReplyButtons();
              // that.loadReplyLink();
              console.log("that.formParam", that.formParam);
            } else {
              that.loadTextReply();
              // that.loadReplyButtons();
              // that.loadReplyLink();
              that.formParam = {
                header: {
                  id: "",
                  title: "",
                  message: "",
                  is_enable_attach_file: false,
                  is_custom_url: false,
                  image_url: "",
                  message_type: "text",
                  button_type: "text_reply"
                },
                detail_button: [
                  {
                    auto_reply_button_id: ""
                  },
                  {
                    auto_reply_button_id: ""
                  },
                  {
                    auto_reply_button_id: ""
                  },
                  {
                    auto_reply_button_id: ""
                  },
                  {
                    auto_reply_button_id: ""
                  },
                  {
                    auto_reply_button_id: ""
                  },
                  {
                    auto_reply_button_id: ""
                  },
                  {
                    auto_reply_button_id: ""
                  },
                  {
                    auto_reply_button_id: ""
                  },
                  {
                    auto_reply_button_id: ""
                  }
                ]
              };
            }
          }, 100);
        }
      },
      deep: true
    }
  },
  computed: {
    headers() {
      return {
        "X-Auth-Token": "Bearer " + this.getXAuthToken()
        // "X-Auth-Agent": "Bearer " + this.getXAuthAgent()
      };
    },
    ...mapGetters(["agentSession"]),
    formParamQRSt() {
      return this.$store.state.automation.formParamQRSt;
    },
    isShowForm() {
      return this.$store.state.automation.isShowForm;
    },
    titleLength() {
      return String(this.formParam.header.title || "").length;
    }
  },
  methods: {
    settabMessage(value) {
      this.tabMessage = value;
    },
    addRow() {
      let newRow = {
        select_variable: "conversation",
        condition: "",
        text: ""
      };
      this.formParam.detail_some.push(newRow);
    },
    removeRow(removeIndex, maxIndex) {
      // console.log("removeIndex", removeIndex, maxIndex);
      if (removeIndex == 0 && maxIndex == 0) {
        return;
      }

      if (removeIndex > -1) {
        // only splice array when item is found
        this.formParam.detail_some.splice(removeIndex, 1); // 2nd parameter means remove one item only
      }
    },
    async loadTextReply() {
      this.buttonsLoading = await true;
      this.textReplyParams.page = 0;
      await this.$store
        .dispatch("automation/listTextReply", this.textReplyParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.textReplyRows = data.data;
          this.buttonsLoading = false;
        })
        .catch(error => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
    async loadReplyButtons() {
      this.buttonsLoading = await true;
      this.buttonsParams.page = 0;
      await this.$store
        .dispatch("automation/listReplyButtons", this.buttonsParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.buttonsRows = data.data;
          this.buttonsLoading = false;
        })
        .catch(error => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
      async loadReplyLink() {
      this.buttonsLoading = await true;
      this.linkParams.page = 0;
      await this.$store
        .dispatch("automation/listReplyLink", this.linkParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.linkRows = data.data;
          this.buttonsLoading = false;
        })
        .catch(error => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
    resetDetailButton() {
      this.formParam.detail_button = [
        {
          auto_reply_button_id: ""
        },
        {
          auto_reply_button_id: ""
        },
        {
          auto_reply_button_id: ""
        },
        {
          auto_reply_button_id: ""
        },
        {
          auto_reply_button_id: ""
        },
        {
          auto_reply_button_id: ""
        },
        {
          auto_reply_button_id: ""
        },
        {
          auto_reply_button_id: ""
        },
        {
          auto_reply_button_id: ""
        },
        {
          auto_reply_button_id: ""
        }
      ];
    },
  
    addTemplateToMesage(template) {
      this.formParam.header.message += template;
    },
    addTemplateToMesage2(template) {
      this.formParam.header.message_away += template;
    },
    currentDateTimeUTC() {
      return currentDateTimeUTC();
    },
    resetValidation() {
      this.errors = {
        title: "",
        message: "",
        attachment: "",
        form: ""
      };
    },
    validateForm() {
      this.resetValidation();

      const title = String(this.formParam.header.title || "").trim();
      const message = String(this.formParam.header.message || "").trim();
      const imageUrl = String(this.formParam.header.image_url || "").trim();

      if (!title) {
        this.errors.title = "Judul Quick Reply wajib diisi.";
      } else if (title.length > this.titleMaxLength) {
        this.errors.title = "Judul Quick Reply maksimal 50 karakter.";
      }

      if (!message) {
        this.errors.message = "Pesan WhatsApp wajib diisi.";
      }

      if (this.formParam.header.is_enable_attach_file == true && !imageUrl) {
        this.errors.attachment =
          "Lampiran wajib diunggah atau diisi URL file-nya.";
      }

      if (
        this.formParam.header.footer_message_status == true &&
        String(this.formParam.header.footer_message || "").length > 30
      ) {
        this.errors.form = "Footer message maksimal 30 karakter.";
      }

      return !Object.keys(this.errors).some(key => this.errors[key] !== "");
    },
    resetCreatedForm() {
      this.formParam = {
        header: {
          id: "",
          title: "",
          message: "",
          is_enable_attach_file: false,
          footer_message: "",
          footer_message_status: false,
          is_custom_url: false,
          image_url: "",
          message_type: "text",
          button_type: "text_reply",
          button_type_away_message: "text_reply"
        },
        detail_button: Array.from({ length: 10 }, () => ({
          auto_reply_button_id: ""
        }))
      };
      this.files = [];
      this.uploadMessageType = "image";
      this.showAdvanced = false;
      this.resetValidation();
    },
    getSaveErrorMessage(error) {
      let message = "";

      if (
        error &&
        error.response &&
        error.response.data &&
        (error.response.data.msg || error.response.data.message)
      ) {
        message = String(
          error.response.data.msg || error.response.data.message
        ).replace(/<br\s*\/?>/gi, " ");
      } else if (error && error.message) {
        message = String(error.message).replace(/<br\s*\/?>/gi, " ");
      }

      const lower = message.toLowerCase();
      if (lower.indexOf("title must be") !== -1) {
        return "Judul Quick Reply maksimal 50 karakter.";
      }
      if (lower.indexOf("respond message is required") !== -1) {
        return "Pesan WhatsApp wajib diisi.";
      }
      if (lower.indexOf("file or image is required") !== -1) {
        return "Lampiran wajib diunggah atau diisi URL file-nya.";
      }
      if (lower.indexOf("footer message must be") !== -1) {
        return "Footer message maksimal 30 karakter.";
      }

      return message || "Gagal menyimpan Quick Reply. Silakan coba lagi.";
    },
    async saveForm(isExit = 0, isDraft = 0) {
      if (this.isSending) {
        return;
      }

      if (!this.validateForm()) {
        return;
      }

      const isCreate = !this.formParam.header.id;
      this.isSending = true;
      this.errors.form = "";

      if (this.formParam.header.footer_message_status == false) {
        this.formParam.header.footer_message = "";
      }

      this.formParam.header.is_publish = isDraft == 1 ? 0 : 1;
      this.formParam.header.title = String(
        this.formParam.header.title || ""
      ).trim();
      this.formParam.header.message = this.remove_tags(
        this.formParam.header.message
      );

      try {
        const response = await this.$store.dispatch(
          "automation/storeQuickReply",
          this.formParam
        );

        this.$fire({
          title: "Berhasil",
          text: response["msg"] || "Quick Reply berhasil disimpan.",
          type: "success",
          timer: 2000
        });

        this.searchData();

        if (isExit == 1 && this.$refs.dismisModal) {
          this.$refs.dismisModal.click();
        }

        if (isCreate) {
          this.resetCreatedForm();
        }
      } catch (error) {
        this.errors.form = this.getSaveErrorMessage(error);
      } finally {
        this.isSending = false;
      }
    },
    remove_tags(html) {
      var html = html.replace("<br />", "||br||");
      var tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      html = tmp.textContent || tmp.innerText;
      return html.replace("||br||", "<br />");
    },
    emojiToggle(isClosed) {
      // console.log("clicked toggle");
      if (typeof isClosed == "undefined") {
        if (this.emojiAttr.open == true) {
          this.emojiAttr.open = false;
        } else {
          this.emojiAttr.open = true;
        }
      } else {
        this.emojiAttr.open = isClosed;
      }

      if (this.emojiAttr.open == true) {
        this.emojiAttr.width = "96%";
        this.emojiAttr.height = "250px";
      } else {
        this.emojiAttr.width = "0%";
        this.emojiAttr.height = "0px";
      }

      // console.log("this.emojiAttr.open:: ", this.emojiAttr.open);
    },
    selectedEmoji(args) {
      this.formParam.header.message += args.emoji;
      // console.log(args); /* return {...}*/
    },

    updateMessageSupportCurrent(msgType) {
      this.uploadMessageSupportSelected = msgType;
    },
    updateMessageTypeCurrent(msgType) {
      if (msgType == "") {
        var that = this;
        setTimeout(function() {
          // console.log(
          //   "that.formParam.header.is_enable_attach_file",
          //   that.formParam.header.is_enable_attach_file
          // );
          if (that.formParam.header.is_enable_attach_file == true) {
            that.formParam.header.message_type = "image";
            that.uploadMessageType = that.formParam.header.message_type;
            // that.formParam.header.is_custom_url = false;
            // console.log("that.uploadMessageTyp",that.uploadMessageType)
          } else {
            that.formParam.header.message_type = "text";
          }
        }, 100);
      } else {
        this.uploadMessageType = msgType;
        this.formParam.header.message_type = msgType;
      }
    },
    inputFileHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.$refs.uploadbc.active = true;
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      console.log("newFile, oldFile", newFile, oldFile);
      if (newFile && !oldFile) {
        // Before adding a file
        // 添加文件前
        // Filter system files or hide files
        // 过滤系统文件 和隐藏文件
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        // 过滤 php html js 文件
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
        // Automatic compression
        // 自动压缩
        if (
          newFile.file &&
          newFile.error === "" &&
          newFile.type.substr(0, 6) === "image/" &&
          this.autoCompress > 0 &&
          this.autoCompress < newFile.size
        ) {
          // console.log("compressing", newFile, oldFile);

          newFile.error = "compressing";
          const imageCompressor = new ImageCompressor(null, {
            convertSize: 1024 * 1024,
            maxWidth: 512,
            maxHeight: 512
          });
          imageCompressor
            .compress(newFile.file)
            .then(file => {
              this.$refs.uploadbc.update(newFile, {
                error: "",
                file,
                size: file.size,
                type: file.type
              });
            })
            .catch(err => {
              this.$refs.uploadbc.update(newFile, {
                error: err.message || "compress"
              });
            });
        }
      }
      console.log("humb newFile, oldFile: ", newFile, oldFile);
      if (
        newFile &&
        newFile.error === "" &&
        newFile.file &&
        (!oldFile || newFile.file !== oldFile.file)
      ) {
        // Create a blob field
        // 创建 blob 字段
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // Thumbnails
        // 缩略图
        newFile.thumb = "";
        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
      // image size
      // image 尺寸
      if (
        newFile &&
        newFile.error === "" &&
        newFile.type.substr(0, 6) === "image/" &&
        newFile.blob &&
        (!oldFile || newFile.blob !== oldFile.blob)
      ) {
        newFile.error = "image parsing";
        let img = new Image();
        img.onload = () => {
          this.$refs.uploadbc.update(newFile, {
            error: "",
            height: img.height,
            width: img.width
          });
        };
        img.οnerrοr = e => {
          console.log("errorr", e);
          this.$refs.uploadbc.update(newFile, { error: "parsing image size" });
        };
        img.src = newFile.blob;
      }
    },
    inputFile(newFile, oldFile) {
      // console.log("inputFile:oldddd", oldFile);
      // console.log("inputFile:newf", newFile);
      if (newFile && oldFile) {
        console.log("oldddd", oldFile);
        console.log("newf", newFile);
        // update
        if (newFile.active && !oldFile.active) {
          //buildData
          let dataArr = {
            message_type: this.uploadMessageType
          };
          // this.$store.dispatch("omniwa/actFilesMessageHandler", dataArr);
          this.objFilesMessageHandler = dataArr;
          this.$refs.uploadbc.update(newFile, { data: dataArr });

          // beforeSend
          // min size
          if (
            newFile.size >= 0 &&
            this.minSize > 0 &&
            newFile.size < this.minSize
          ) {
            this.$refs.uploadbc.update(newFile, { error: "size" });
          }
        }
        if (newFile.progress !== oldFile.progress) {
          // progress
          console.log("progress", newFile.progress);
        }
        if (newFile.error && !oldFile.error) {
          console.log("err", newFile.error.response);
          console.log("newFile", newFile);
          this.$refs.uploadbc.update(newFile, { progress: 0 });

          // error
          this.$fire({
            title: "Error",
            text: newFile.response.msg,
            type: "error",
            timer: 1000
          }).then(r => {});
        }
        if (newFile.success && !oldFile.success) {
          this.formParam.header.image_url = newFile.response.data.url;
          this.errors.attachment = "";
          this.caption = "";
          this.thumbUpload.push(newFile.thumb);
          // success
          // console.log("this.thumbUpload", this.thumbUpload);
          console.log("success", newFile.success, newFile);
        }
      }
      if (!newFile && oldFile) {
        this.formParam.header.image_url = "";
        // remove
        if (oldFile.success && oldFile.response.id) {
        }
      }
      // Automatically activate upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (this.uploadAuto && !this.$refs.uploadbc.active) {
          this.$refs.uploadbc.active = true;
        }
      }
    },
    formatSizes(bytes) {
      return formatSizes(bytes);
    },
    getExt(filename) {
      return filename.split(".").pop();
    },
    getXAuthToken() {
      return getXAuthToken();
    },
    getXAuthAgent() {
      return getXAuthAgent();
    },
    getWhatsappNumberFromJid(jid) {
      return getWhatsappNumberFromJid(jid);
    },
    APICoreV2() {
      return APICoreV2();
    },
    APICore() {
      return APICore();
    }
  },
  async created() {},
  beforeDestroy() {},
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "buttons-add"
};
</script>

<style scoped>
.qr-editor-modal .modal-dialog {
  max-width: 1180px;
}

.qr-editor-modal-content {
  overflow: hidden;
  border: 0;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.18);
}

.qr-editor-header {
  align-items: flex-start;
  padding: 22px 26px 16px;
  border-bottom: 1px solid #eef2f7;
}

.qr-editor-header .modal-title {
  margin: 0;
  color: #101828;
  font-size: 20px;
  font-weight: 700;
}

.qr-editor-subtitle {
  margin: 5px 0 0;
  color: #667085;
  font-size: 13px;
}

.qr-editor-body {
  max-height: calc(100vh - 190px);
  padding: 22px 26px;
  overflow-y: auto;
  background: #f8fafc;
}

.qr-editor-grid {
  margin-right: -10px;
  margin-left: -10px;
}

.qr-editor-grid > .qr-editor-left,
.qr-editor-grid > .qr-editor-right {
  padding-right: 10px;
  padding-left: 10px;
}

.qr-form-section {
  margin-bottom: 18px;
  padding: 18px;
  background: #ffffff;
  border: 1px solid #e8edf3;
  border-radius: 13px;
}

.qr-field-label {
  display: block;
  margin-bottom: 7px;
  color: #344054;
  font-size: 13px;
  font-weight: 700;
}

.qr-title-input-wrap {
  position: relative;
}

.qr-title-input {
  height: 44px;
  padding-right: 62px;
  border-color: #d0d5dd;
  border-radius: 9px;
  font-size: 14px;
}

.qr-title-input:focus,
.qr-input:focus,
.qr-select:focus {
  border-color: #f99a43;
  box-shadow: 0 0 0 3px rgba(249, 154, 67, 0.14);
}

.qr-title-input-wrap.is-invalid .qr-title-input {
  border-color: #f04438;
}

.qr-char-count {
  position: absolute;
  top: 50%;
  right: 12px;
  color: #98a2b3;
  font-size: 11px;
  transform: translateY(-50%);
}

.qr-field-help {
  margin: 7px 0 0;
  color: #98a2b3;
  font-size: 12px;
  line-height: 1.5;
}

.qr-field-error {
  margin: 7px 0 0;
  color: #d92d20;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.45;
}

.qr-alert {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 16px;
  padding: 11px 13px;
  border: 1px solid transparent;
  border-radius: 9px;
  font-size: 13px;
  line-height: 1.5;
}

.qr-alert.is-error {
  color: #b42318;
  background: #fef3f2;
  border-color: #fecdca;
}

.qr-advanced-section {
  padding: 0;
  overflow: hidden;
}

.qr-section-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 15px 18px;
  color: #344054;
  background: #ffffff;
  border: 0;
  font-size: 13px;
  font-weight: 700;
  text-align: left;
}

.qr-section-toggle small {
  color: #98a2b3;
  font-size: 11px;
  font-weight: 500;
}

.qr-section-toggle .fa {
  margin-right: 5px;
  color: #b45309;
}

.qr-advanced-body {
  padding: 0 18px 18px;
  border-top: 1px solid #eef2f7;
}

.qr-subsection {
  padding-top: 16px;
}

.qr-subsection + .qr-subsection {
  margin-top: 16px;
  border-top: 1px dashed #e8edf3;
}

.qr-subsection-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.qr-subsection-head strong {
  display: block;
  color: #344054;
  font-size: 13px;
  font-weight: 700;
}

.qr-subsection-head small {
  display: block;
  margin-top: 2px;
  color: #98a2b3;
  font-size: 11px;
}

.qr-switch {
  position: relative;
  display: inline-block;
  flex: 0 0 auto;
  width: 40px;
  height: 22px;
  margin: 0;
}

.qr-switch input {
  width: 0;
  height: 0;
  opacity: 0;
}

.qr-switch-slider {
  position: absolute;
  inset: 0;
  background: #d0d5dd;
  border-radius: 999px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.qr-switch-slider:before {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 16px;
  height: 16px;
  background: #ffffff;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.2);
  content: "";
  transition: transform 0.2s ease;
}

.qr-switch input:checked + .qr-switch-slider {
  background: #f99a43;
}

.qr-switch input:checked + .qr-switch-slider:before {
  transform: translateX(18px);
}

.qr-attachment-body,
.qr-custom-url {
  margin-top: 12px;
}

.qr-custom-url {
  margin-bottom: 0;
}

.qr-input,
.qr-select {
  height: 40px;
  border-color: #d0d5dd;
  border-radius: 8px;
  font-size: 13px;
}

.qr-check-inline {
  display: flex;
  align-items: center;
  gap: 7px;
  height: 40px;
  margin: 0;
  color: #475467;
  font-size: 12px;
  font-weight: 500;
}

.qr-upload-area {
  position: relative;
  margin-top: 12px;
}

.qr-drop-zone {
  padding: 22px 14px;
  color: #667085;
  background: #fbfcfe;
  border: 1px dashed #d0d5dd;
  border-radius: 10px;
  text-align: center;
}

.qr-drop-zone .upload-text label {
  margin: 6px 0 0;
  color: #b45309;
  font-size: 12px;
  cursor: pointer;
}

.qr-hidden-upload {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
}

.qr-file-preview {
  margin-top: 12px;
}

.qr-file-preview img {
  max-width: 100%;
  max-height: 180px;
  border: 1px solid #e8edf3;
  border-radius: 10px;
}

.qr-file-preview a {
  color: #b45309;
  font-size: 12px;
  font-weight: 600;
}

.qr-editor-right {
  position: sticky;
  top: 0;
  align-self: flex-start;
}

.qr-preview-panel {
  background: #ffffff;
  border: 1px solid #e8edf3;
  border-radius: 14px;
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.05);
}

.qr-preview-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding: 17px 18px 13px;
  border-bottom: 1px solid #eef2f7;
}

.qr-preview-header h6 {
  margin: 0;
  color: #101828;
  font-size: 14px;
  font-weight: 700;
}

.qr-preview-header p {
  margin: 3px 0 0;
  color: #98a2b3;
  font-size: 11px;
}

.qr-preview-badge {
  flex: 0 0 auto;
  padding: 3px 7px;
  color: #b45309;
  background: #fff7e8;
  border-radius: 999px;
  font-size: 9px;
  font-weight: 700;
}

.qr-preview-canvas {
  min-height: 320px;
  max-height: 520px;
  padding: 16px;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #efeae2;
  background-image: radial-gradient(rgba(255, 255, 255, 0.35) 1px, transparent 1px);
  background-size: 18px 18px;
}

.qr-preview-canvas /deep/ .chat {
  background: transparent;
}

.qr-preview-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 16px;
  color: #667085;
  background: #f0f7ff;
  border-radius: 0 0 14px 14px;
  font-size: 11px;
  line-height: 1.5;
}

.qr-preview-note i {
  margin-top: 2px;
  color: #2e90fa;
}

.qr-preview-note strong,
.qr-preview-note span {
  display: block;
}

.qr-preview-note strong {
  color: #344054;
  font-weight: 700;
}

.qr-editor-footer {
  justify-content: space-between;
  gap: 12px;
  padding: 14px 26px;
  background: #ffffff;
  border-top: 1px solid #eef2f7;
}

.qr-footer-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.qr-btn-secondary,
.qr-btn-primary,
.qr-btn-link {
  min-height: 38px;
  border-radius: 9px;
  font-size: 13px;
  font-weight: 700;
}

.qr-btn-secondary {
  color: #475467;
  background: #ffffff;
  border: 1px solid #d0d5dd;
}

.qr-btn-secondary:hover {
  color: #b45309;
  background: #fffaf3;
  border-color: #f6d49b;
}

.qr-btn-primary {
  min-width: 118px;
  border-color: #f99a43;
  background: #f99a43;
}

.qr-btn-primary:hover {
  border-color: #ef8c32;
  background: #ef8c32;
}

.qr-btn-link {
  color: #667085;
  background: transparent;
  border: 0;
}

.qr-btn-link:hover {
  color: #b45309;
  background: #fff7e8;
}

@media (max-width: 991.98px) {
  .qr-editor-body {
    max-height: none;
  }

  .qr-editor-right {
    position: static;
    margin-top: 18px;
  }

  .qr-preview-canvas {
    max-height: 420px;
  }
}

@media (max-width: 575.98px) {
  .qr-editor-header,
  .qr-editor-body,
  .qr-editor-footer {
    padding-right: 16px;
    padding-left: 16px;
  }

  .qr-editor-footer {
    align-items: stretch;
    flex-direction: column;
  }

  .qr-footer-actions {
    flex-direction: column-reverse;
  }

  .qr-footer-actions .btn,
  .qr-editor-footer > .btn {
    width: 100%;
  }

  .qr-section-toggle {
    align-items: flex-start;
    flex-direction: column;
    gap: 3px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/automation/quickReply/form.vue